import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './i18n/LanguageContext';
import { Toaster } from 'sonner';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import International from './pages/International';
import Sustainability from './pages/Sustainability';
import Contact from './pages/Contact';
import Brochure from './pages/Brochure';
import NotFound from './pages/NotFound';

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/empresa" element={<About />} />
              <Route path="/servicios" element={<Services />} />
              <Route path="/internacional" element={<International />} />
              <Route path="/idi" element={<Sustainability />} />
              <Route path="/contacto" element={<Contact />} />
              <Route path="/brochure" element={<Brochure />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Layout>
          <Toaster
            position="bottom-right"
            toastOptions={{
              style: {
                background: '#1A2E25',
                color: '#F4F1EA',
                border: '1px solid rgba(244,241,234,0.15)',
                borderRadius: 0,
                fontFamily: 'Chivo, system-ui, sans-serif',
              },
            }}
          />
        </BrowserRouter>
      </LanguageProvider>
    </div>
  );
}

export default App;
